import PropTypes from "prop-types";
import { t } from "@/i18n-js/instance";
import { StatusBadge } from "@circle-react-uikit/StatusBadge";

export const StatusCell = ({ status }) => {
  const statusStates = {
    active: {
      label: t("settings.paywalls.status.active"),
      variant: "success",
    },
    inactive: {
      label: t("settings.paywalls.status.inactive"),
      variant: "default",
    },
    draft: {
      label: t("settings.paywalls.status.draft"),
      variant: "default",
    },
    notIdentified: {
      label: "",
      variant: "default",
    },
  };

  const selectedStatusObject =
    statusStates[status] ?? statusStates["notIdentified"];

  return (
    <StatusBadge variant={selectedStatusObject.variant}>
      {selectedStatusObject.label}
    </StatusBadge>
  );
};

StatusCell.propTypes = {
  status: PropTypes.string.isRequired,
};
